import React, { useState, useEffect, useRef } from 'react';
import { List, Datagrid, FunctionField, SimpleList } from 'react-admin';
import { vehicleSvgs } from "./sharedData";
import { useMediaQuery, Avatar, makeStyles, FormControl, InputLabel, Select, MenuItem, IconButton, Paper, Typography, Tooltip, Button } from '@material-ui/core';
import { customTheme } from "./customTheme";
import ScrollableTable from './components/ScrollableTable';
import moment from 'moment'
import CustomSearch from './components/CustomSearch';
import CustomDateTimePicker from "./components/CustomDateTimePickerV4";
import { useLocation } from 'react-router-dom';
import CustomPagination from './components/CustomPagination';
import ParkingSearchSelector from './components/ParkingSearchSelector';
import ShowTimePeriod from './components/ShowTimePeriod';
import ClearIcon from '@material-ui/icons/Clear';
import notify from './components/CustomUseNotify';
import "./css/ValetUsers.css";
import Skeleton from '@material-ui/lab/Skeleton';
import config from "./config.json"
import RightSideArrow from './images/rigit_side_arrow_svg.svg';
import CustomExportButton from './components/CustomExportButton';
import queryString from 'query-string';
import { saveTokens } from './utils/saveTokens';
import RightTickImg from './images/right_tick_img.svg'
import { AnalyticDistributionImgs } from "./sharedData";
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import downArrow from './images/down.png'
import sideArrow from './images/side.png'
// import ImageGalleryDialog from './components/ImageGalleryDialog';
import CustomFilter from './components/CustomFilter';
import MultipleImageViewerWithText from './components/MultipleImageViewerWithText';

const useStyles = makeStyles({
    list: {
        marginBottom: 0,
    },
    parkingSelectorContainer: {
        display: "grid",
        justifyContent: "space-between",
    },
    dialogPaper: {
        borderRadius: 15,
        padding: "5px 15px 15px",
        maxWidth: 350
    },
    dialogButton: {
        borderRadius: 100,
        padding: "8px 25px"
    },
    dialogPaperBig: {
        borderRadius: 15,
        padding: "5px 5px 10px",
    },
    input: {
        width: "500px"
    },
    MuiInputBase: {
        root: {
            width: "800px"
        }
    },
    chipCell: {
        textAlign: "center",
        padding: customTheme.spacing(1, 2),
        display: "inline-block",
        borderRadius: 50,
        minWidth: 100,
    },
    timeFilterContainer: {
        alignItems: "center",
        marginTop: customTheme.spacing(5),
    },
    timeFilterInput: {
        marginLeft: "2%",
    },
    outlinedInput: {
        padding: 0,
    },
    timeFilterButton: {
        marginLeft: "1%",
        width: "10%",
        minWidth: 85
    },
    summaryListRoot: {
        marginTop: customTheme.spacing(2),
    },
    summaryCardContainer: {
        display: "grid",
        gridAutoFlow: "column",
        marginTop: customTheme.spacing(3),
    },
    flexContainer: {
        display: 'flex',
        alignItems: "center",
    },
    listActions: {
        justifyContent: "space-between",
        marginTop: customTheme.spacing(3),
    },
    mainTableCell: {
        color: `${customTheme.palette.grey[900]} !important`,
        fontWeight: 500,
    },
    listVehicleIcon: {
        width: 25,
        height: 25,
        marginRight: customTheme.spacing(1),
        verticalAlign: "middle",
    },
    showLayoutMain: {
        marginTop: 0,
    },
    showTitle: {
        fontSize: 22,
    },
    searchParamsTitle: {
        fontSize: "1.05rem",
    },
    searchParams: {
        fontFamily: "Poppins-Regular",
        fontSize: "0.95rem",
    },
    asyncSelector: {
        display: "grid",
        gridAutoFlow: "column",
        justifyContent: "space-between",
        paddingRight: 5,
    },
    removeMargin: {
        margin: 0,
    },
    parkingListHead: {
        color: customTheme.palette.grey[500],
    },
    inlineForm: {
        display: "grid",
        gridAutoFlow: "column",
        padding: "18px 2%",
        marginLeft: 15
    },
    removeUnderline: {
        borderBottom: "none",
    },
    checkIconButton: {
        borderRadius: 4,
        padding: "5px 5px 2px",
        '&:hover': {
            backgroundColor: "#0001 !important",
            cursor: "pointer",
        },
    },
    smallSelectRoot: {
        padding: "10px 32px 10px 18px",
    },
    receiptTextContainer: {
        display: "flex",
        padding: "15px 20px",
        '&:hover': {
            backgroundColor: "#00336608",
        },
        alignItems: "center",
        marginBottom: 15,
        border: "1px solid #bfbfbf",
        borderRadius: 4,
    },
    selectWithIcon: {
        display: "flex",
        justifyContent: "space-between",
        paddingLeft: 20,
        paddingRight: "40px !important",
        columnGap: 30,
    },
    editSummaryTime: {
        color: "#888",
        fontSize: 20,
        marginLeft: 10,
        '&:hover': {
            cursor: "pointer",
            opacity: 0.7,
        }
    },
    backDrop: {
        backgroundColor: "#00000042"
    },
    statusCircle: {
        width: 7,
        height: 7,
        borderRadius: 10,
    },
    columnLink: {
        display: 'flex',
        alignItems: 'center',
        '&:hover': {
            cursor: 'pointer',
        }
    },
    timeRangeButton: {
        flex: 1,
        padding: "10px 20px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        "&:hover": {
            cursor: "pointer",
            backgroundColor: "#eee"
        }
    },
    title: {
        fontSize: 13,
        color: customTheme.palette.secondary.main,
    },
    mainValue: {
        fontSize: 28,
        color: customTheme.palette.primary.main,
        fontWeight: customTheme.typography.fontWeightMedium
    },
    summaryBox: {
        padding: customTheme.spacing(3, 3),
    },
    twoColumnGrid: {
        padding: customTheme.spacing(1, 0, 2),
        display: "grid",
    },
    summaryVehicleIcon: {
        width: 18
    },
    summaryBoxLabel1: {
        fontSize: 12,
        color: "#A3BBD9",
        margin: customTheme.spacing(0, 2, 0, 1),
    },
    summaryBoxLabel2: {
        fontSize: 12,
        color: "#A3BBD9",
        margin: customTheme.spacing(0, 2, 0, 1),
    },
    paymentSummaryBoxLabel1: {
        fontSize: 12,
        color: customTheme.palette.grey[500],
    },
    summaryBoxValue1: {
        fontSize: 12,
        color: "#334D6E",
        fontWeight: customTheme.typography.fontWeightMedium
    },
    tooltip: {
        fontSize: 9,
        fontFamily: "Poppins-Regular",
        fontWeight: "normal"
    }
});

const progressBarColor = ["#16CC69", "#5E8DD3", "#334D6E", "#F7685B", "#16CC69", "#5E8DD3", "#334D6E", "#F7685B"]

const PAYMENT_STATUS = {
    "SUCCESS": {label:"Paid", color: "#18CC69", backgroundColor: "#18CC6919" },
    "FAILED": {label:"Failed", color: "#F74E3D", backgroundColor: "#F74E3D19" },
    "PENDING": {label:"Unpaid", color: "#F74E3D", backgroundColor: "#F74E3D19" },
    "INITIATED": {label:"Unpaid", color: "#F74E3D", backgroundColor: "#F74E3D19" },
    "CANCELLED": {label:"Cancelled", color: "#F74E3D", backgroundColor: "#F74E3D19" },
    "NOT_CAPTURED": {label:"Unpaid", color: "#F74E3D", backgroundColor: "#F74E3D19" },
    "REFUNDED": {label:"Refunded", color: "#18CC69", backgroundColor: "#18CC6919" },
    "REFUND_INITIATED": {label:"Refund Initiated", color: "#334D6E", backgroundColor: "#334D6E19" },
    "DEFAULT": {label:"Unknown", color: "#334D6E", backgroundColor: "#EBEFF2"}
};

// const renderVehicleType = row => (
//     row.vehicle_type ?
//         <div style={{ display: 'flex', alignItems: "center", justifyContent: "center" }}>
//             <img src={vehicleSvgs[row.vehicle_type]} style={{ width: 25, height: 25, marginRight: 4 }} alt={row.vehicle_type_label} />
//         </div>
//         :
//         null
// );

let valetSummaryInitState = {
    "data": {
        "Collected": {
            "types": {
                "Advance": {
                    "count": 50,
                    "percentage": 50
                },
                "On Site": {
                    "count": 50,
                    "percentage": 50
                },
            },
            "totalSum": 100
        },
        "Handed Over": {
            "types": {
                "Advance": {
                    "count": 50,
                    "percentage": 50
                },
                "On Site": {
                    "count": 50,
                    "percentage": 50
                },
            },
            "totalSum": 100
        },
        "Amount": {
            "types": {
                "Cash": {
                    "count": 50,
                    "percentage": 50
                },
                "UPI": {
                    "count": 50,
                    "percentage": 50
                },
            },
            "totalSum": 100
        },
        "Advance Booking": {
            "totalSum": 100
        },

    },
    "loading": true,
    "isInitState": true
}

let valetActivityWiseSummaryInitState = {
    "data": {
        "Operator 1": {
            "types": {
                "Advance": {
                    "count": 50,
                    "percentage": 50
                },
                "On Site": {
                    "count": 50,
                    "percentage": 50
                },
            },
            "totalSum": 100
        },
        "Operator 2": {
            "types": {
                "Advance": {
                    "count": 50,
                    "percentage": 50
                },
                "On Site": {
                    "count": 50,
                    "percentage": 50
                },
            },
            "totalSum": 100
        },
        "Operator 3": {
            "types": {
                "Cash": {
                    "count": 50,
                    "percentage": 50
                },
                "UPI": {
                    "count": 50,
                    "percentage": 50
                },
            },
            "totalSum": 100
        },
    },
    "loading": false,
    "isInitState": true
}

export const ValetBookings = (props) => {
    const classes = useStyles()
    const listDataRef = useRef();
    const isSmallDevice = useMediaQuery(theme => customTheme.breakpoints.down("xs"));
    const location = useLocation();
    const [showFilter] = useState(sessionStorage.getItem("show_filter") === "1");
    let prevSearch = sessionStorage.getItem(location.pathname) ? JSON.parse(sessionStorage.getItem(location.pathname)) : ""
    const [currentParking, setCurrentParking] = useState(prevSearch.currentParking ? prevSearch.currentParking : {});
    const [displayModal, setDisplayModal] = useState(false);
    const [valetDetails, setValetDetails] = useState(null)
    const zoneIds = currentParking.zone_ids ? currentParking.zone_ids.split(",") : null;
    const zoneLabels = currentParking.zones ? currentParking.zones.split(";") : null;
    const finalZones = zoneIds && zoneLabels ? zoneIds.map((id, index) => (
        { id, name: zoneLabels[index] }
    )) : null;
    if (finalZones)
        finalZones.sort((a, b) => (a.name > b.name ? 1 : (a.name < b.name ? -1 : 0)));

    const [startDateTime, setStartDateTime] = useState(null);
    const [endDateTime, setEndDateTime] = useState(null);
    const [search, setSearch] = useState(prevSearch.inputSearch)
    let searchTypeState = ["Vehicle Number", "Name", "Mobile"]
    const [searchTypes, setSearchTypes] = useState(prevSearch.type ? prevSearch.type : "Vehicle Number");

    const [showTiles, setShowTiles] = useState(true)
    const [valetSummary, setValetSummary] = useState(valetSummaryInitState)
    const [valetActivityWiseSummary, setValetActivityWiseSummary] = useState(valetActivityWiseSummaryInitState)
    const [activityType, setActivityType] = useState(null)
    const [filterListValue, setFilterListValue] = useState(prevSearch.radioValue ? prevSearch.radioValue : null)
    const [settingFilterFormat, setSettingFilterFormat] = useState({})
    const abortValetBookingsSummaryRequest = useRef(null);
    const filter = { ...settingFilterFormat, start_time: startDateTime ? moment(startDateTime).format("YYYY-MM-DD HH:mm:ss") : "", end_time: endDateTime ? moment(endDateTime).format("YYYY-MM-DD HH:mm:ss") : "", search: { value: search ? search : "", type: searchTypes ? searchTypes : "" }, access_key: currentParking.id, parking_info_id: currentParking.allZones ? currentParking.parking_info_id : undefined };

    let filterTypesInitState = [
        {
            filterType: "Valet Status",
            dataList: [{ name: "Car Collected", id: 1 }, {name: "Car Parked", id: 2}, {name: "Car Recall", id: 3}, {name:"Car Arrived", id: 4}, {name: "Car Handover", id: 5}],
            listType: "Static",
            caseType: "Static",
            showFilter: true
        },
        {
            filterType: "Booking Type",
            dataList: [{ name: "Advance", id: 1 }, { name: "On Site", id: 2 }],
            listType: "Static",
            caseType: "Static",
            showFilter: true
        },
    ]

    const onParkingChange = (parking) => {
        setCurrentParking({ ...parking, allZones: true });
    };

    const onZoneChange = (event) => {
        setCurrentParking({
            ...currentParking,
            id: event.target.value,
            name: zoneLabels[zoneIds.findIndex(id => id === event.target.value)],
            allZones: event.target.value === "All"
        });
    };

    const getExportFile = (fileType) => {
        const { current: { total, currentSort, filterValues } } = listDataRef
        const params = {
            filter: JSON.stringify({ ...filter, ...filterValues }),
            sort: JSON.stringify([currentSort.field, currentSort.order]),
            page: 1,
            perPage: total,
            user_id: sessionStorage.getItem("user_id")
        };
        fetch(`${config.HOST_NAME}/crm/v3/valets/bookings?${queryString.stringify(params)}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
                'RefreshToken': `Bearer ${sessionStorage.getItem('refresh_token')}`,
                'Accept': `application/${fileType}`,
            },
        })
            .then(response => {
                saveTokens(response)
                return response.blob()
            })
            .then(blob => {
                const url = URL.createObjectURL(blob);
                const tempLinkElement = document.createElement('a');
                tempLinkElement.href = url;
                tempLinkElement.setAttribute('download', `Valet Bookings.${fileType}`);
                tempLinkElement.click();
            })
            .catch(error => {
                notify('Error Exporting Data', 'warning');
            });
    };

    const getExcelFile = () => {
        getExportFile("xlsx");
    };

    const getValetSummary = () => {
        if (abortValetBookingsSummaryRequest.current) abortValetBookingsSummaryRequest.current.abort()
            abortValetBookingsSummaryRequest.current = new AbortController();
        setValetSummary({ loading: true, data: valetSummaryInitState.data, isInitState: true })
        const params = {
            access_key_id: currentParking.id,
            parking_info_id: currentParking.allZones ? currentParking.parking_info_id : undefined,
            start_time: startDateTime ? moment(startDateTime).format("YYYY-MM-DD HH:mm:ss") : "",
            end_time: endDateTime ? moment(endDateTime).format("YYYY-MM-DD HH:mm:ss") : "",
        }
        fetch(`${config.HOST_NAME}/crm/v3/valets/bookings/tiles?${queryString.stringify(params)}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
                'RefreshToken': `Bearer ${sessionStorage.getItem('refresh_token')}`,
            },
            signal: abortValetBookingsSummaryRequest.current.signal,
        }).then(response => {
            saveTokens(response)
            return response.json()
        })
            .then(responseJson => {
                if (responseJson.success) setValetSummary({ loading: false, data: responseJson.data, isInitState: false });
                else notify(responseJson.message, 'warning');
            })
            .catch((e) => {
                if (e.name === "AbortError") console.log(e);
                else notify('Error Fetching Summary', 'warning')
                console.log(e)
            });
    }

    const getValetActivityWiseSummary = () => {
        setValetActivityWiseSummary({ loading: true, data: {}, isInitState: true })
        const params = {
            access_key_id: currentParking.id,
            parking_info_id: currentParking.allZones ? currentParking.parking_info_id : undefined,
            start_time: startDateTime ? moment(startDateTime).format("YYYY-MM-DD HH:mm:ss") : "",
            end_time: endDateTime ? moment(endDateTime).format("YYYY-MM-DD HH:mm:ss") : "",
            activity_type: activityType === "Collected" ? "CAR_COLLECTION" : activityType === "Handed Over" ? "CAR_HANDOVER" : null
        }
        fetch(`${config.HOST_NAME}/crm/v3/valets/bookings/tiles/filter?${queryString.stringify(params)}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
                'RefreshToken': `Bearer ${sessionStorage.getItem('refresh_token')}`,
            },
        }).then(response => {
            saveTokens(response)
            return response.json()
        })
            .then(responseJson => {
                if (responseJson.success) setValetActivityWiseSummary({ loading: false, data: responseJson.data, isInitState: false });
                else notify(responseJson.message, 'warning');
            })
            .catch((e) => {
                console.log(e)
                notify('Error Fetching Summary', 'warning')
            });
    }

    useEffect(() => {
        getValetSummary()
    }, [currentParking, startDateTime, endDateTime]); // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        if (activityType) getValetActivityWiseSummary()
    }, [currentParking, startDateTime, endDateTime, activityType]); // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        let values = {}
        if (filterListValue) {
            for (let val in filterListValue) {
                if (filterListValue[val].filterType === "Valet Status") values = { ...values, valet_status: filterListValue[val].value ? activitiesValue[filterListValue[val].value] : undefined }
                if (filterListValue[val].filterType === "Booking Type") values = { ...values, booking_type: filterListValue[val].value ? filterListValue[val].value === 'Advance' ? 'APP' : "OPERATOR"  : undefined }
            }
            setSettingFilterFormat(values)
        }
        if (filterListValue === null) setSettingFilterFormat({})
    }, [filterListValue])


    return (
        <div>
            <div className={classes.parkingSelectorContainer} style={{ gridAutoFlow: isSmallDevice ? "row" : "column", gridTemplateColumns: isSmallDevice ? "100%" : "48% 48%", gridRowGap: isSmallDevice ? 18 : 0, margin: 0 }}>
                {showFilter &&
                    <ParkingSearchSelector
                        value={currentParking}
                        onChange={onParkingChange}
                        clearable={true}
                        pathName={location.pathname}
                    />
                }

                {currentParking.zone_ids && currentParking.zone_ids.includes(',') &&
                    <FormControl variant="outlined" style={{ marginTop: isSmallDevice ? 0 : 10 }}>
                        <InputLabel>Zone Name</InputLabel>
                        <Select
                            value={currentParking.allZones ? "All" : currentParking.id}
                            onChange={onZoneChange}
                            label="Zone Name"
                            variant="outlined"
                        >
                            <MenuItem value="All">All</MenuItem>
                            {finalZones.map((zone, index) => (
                                <MenuItem key={index} value={zone.id}>{zone.name}</MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                }
            </div>

            <div className='customStyleForDataSearchDiv'>
                <CustomSearch search={search} setSearch={setSearch} searchTypes={searchTypes} setSearchTypes={setSearchTypes} searchTypeState={searchTypeState} pathName={location.pathname} />
                <CustomDateTimePicker startDateTime={startDateTime} setStartDateTime={setStartDateTime} endDateTime={endDateTime} setEndDateTime={setEndDateTime} />
                <CustomFilter filterTypesInitState={filterTypesInitState} filterListValue={filterListValue} setFilterListValue={setFilterListValue} />
                <CustomExportButton getCSV={getExcelFile} disabled={listDataRef.current && listDataRef.current.total === 0} />
            </div>
            <ShowTimePeriod startDateTimeFilter={startDateTime} endDateTimeFilter={endDateTime} showTiles={showTiles} setShowTiles={setShowTiles} />

            {showTiles &&
                <>
                    <div className='secondaryColor fontWeightSemiBold' style={{ fontSize: 14, marginTop: 10 }}>All Analysis</div>
                    <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr 1fr", justifyContent: "space-between", gap: 15, marginTop: 10 }}>
                        {
                            Object.keys(valetSummary.data).map((value) => (
                                <SummaryCard
                                    title={value}
                                    data={valetSummary.data[value]["types"]}
                                    getValue={data => valetSummary.data[value]["totalSum"]}
                                    getDistributedLabels={data => Object.keys(data).map(val => AnalyticDistributionImgs[val]?.["label"])}
                                    getDistributedValues={data => Object.keys(data).map(val => data[val].count ? data[val].count : 0)}
                                    getDistributedIcons={data => Object.keys(data).map(val => AnalyticDistributionImgs[val]?.["img"])}
                                    getDistributedValuePercentage={data => Object.keys(data).map(val => data[val].percentage ? data[val].percentage : 0)}
                                    getDistributedPercentage={data => Object.keys(data).map((val, i) => {
                                        return { percentage: data[val].percentage ? data[val].percentage.toFixed(2) : 0, color: progressBarColor[i] }
                                    })}
                                    loading={valetSummary.loading}
                                    showDonutChart={true}
                                    showProgressBar={true}
                                    activityType={activityType}
                                    setActivityType={(type) => setActivityType(type)}
                                />
                            ))
                        }
                    </div>

                    {valetActivityWiseSummary && Object.keys(valetActivityWiseSummary.data)[0] && activityType &&
                        <>
                            <div className='secondaryColor fontWeightSemiBold' style={{ fontSize: 14, marginTop: 10 }}>{`All Operators - ${activityType} Breakdown`}</div>
                            <div className='vehicleSummaryCardScroll'>
                                <div className='vehicleSummaryCardFlexScroll'>
                                    {
                                        Object.keys(valetActivityWiseSummary.data).map((value) => (
                                            <SummaryCard
                                                title={value}
                                                data={valetActivityWiseSummary.data[value]["types"]}
                                                getValue={data => valetActivityWiseSummary.data[value]["totalSum"]}
                                                getDistributedLabels={data => Object.keys(data).map(val => AnalyticDistributionImgs[val]?.["label"])}
                                                getDistributedValues={data => Object.keys(data).map(val => data[val].count ? data[val].count : 0)}
                                                getDistributedIcons={data => Object.keys(data).map(val => AnalyticDistributionImgs[val]?.["img"])}
                                                getDistributedValuePercentage={data => Object.keys(data).map(val => data[val].percentage ? data[val].percentage : 0)}
                                                getDistributedPercentage={data => Object.keys(data).map((val, i) => {
                                                    return { percentage: data[val].percentage ? data[val].percentage.toFixed(2) : 0, color: progressBarColor[i] }
                                                })}
                                                loading={valetSummary.loading}
                                                showDonutChart={true}
                                                showProgressBar={true}
                                                activityType={activityType}
                                            />
                                        ))
                                    }
                                </div>
                            </div>
                        </>
                    }

                    {valetActivityWiseSummary.loading &&
                        <>
                            <Skeleton variant="text" height={22} width="200px" style={{marginTop: "10px"}} />
                            <div className='vehicleSummaryCardScroll'>
                                <div className='vehicleSummaryCardFlexScroll'>
                                    <SummaryCard
                                        title={""}
                                        data={""}
                                        getValue={data => ""}
                                        getDistributedLabels={data => ""}
                                        getDistributedValues={data => ""}
                                        getDistributedIcons={data => ""}
                                        getDistributedValuePercentage={data => ""}
                                        getDistributedPercentage={data => Object.keys(data).map((val, i) => {
                                            return ""
                                        })}
                                        loading={true}

                                    />
                                </div>
                            </div>
                        </>
                    }
                </>
            }
            <List
                {...props}
                style={{ marginTop: 10 }}
                empty={false}
                filter={filter}
                title="Valets Bookings"
                bulkActionButtons={false}
                exporter={false}
                actions={false}
                pagination={<CustomPagination setListData={(listData) => { listDataRef.current = listData }} />}
            >

                {isSmallDevice ?
                    <SimpleList
                        leftIcon={row => <Avatar alt={row.vehicle_type_label} src={vehicleSvgs[row.vehicle_type]} style={{ padding: 4, width: 28, height: 28, marginTop: 8, marginRight: 10, overflow: "visible" }} />}
                        primaryText={record => record.vehicle_number.toUpperCase()}
                        secondaryText={record => (<div>
                            {/* {record.model && <div><span style={{ color: "#5a5a5a" }}>Model: </span>{record.model}</div>} */}
                            {record.username && <div><span style={{ color: "#5a5a5a" }}>Name: </span>{record.username}</div>}
                            {record.mobile && <div><span style={{ color: "#5a5a5a" }}>Mob No: </span>{record.mobile}</div>}
                            {record.amount && <div><span style={{ color: "#5a5a5a" }}>Amount: </span>₹{record.amount}</div>}
                            {record.driver_name && <div><span style={{ color: "#5a5a5a" }}>Driver Name: </span>{record.driver_name}</div>}
                            {record.status && <div><span style={{ color: "#5a5a5a" }}>Payment Status: </span>{PAYMENT_STATUS[record.status] ? PAYMENT_STATUS[record.status].label : record.status}</div>}
                            {/* {record.status && <div><span style={{ color: "#5a5a5a" }}>Status: </span>{record.status}</div>} */}
                            {record.payment_portal && <div><span style={{ color: "#5a5a5a" }}>Payment Portal: </span>{record.payment_portal.replace(/_/g, ' ')}</div>}
                            {record.parking_slots_area_name && <div><span style={{ color: "#5a5a5a" }}>Parking Area: </span>{record.parking_slots_area_name}</div>}
                            {record.parking_slot && <div><span style={{ color: "#5a5a5a" }}>Parking Slot: </span>{record.parking_slot}</div>}
                            {record.created_on && <div><span style={{ color: "#5a5a5a" }}>Booking Date: </span>{moment(record["created_on"]).format("YYYY-MM-DD hh:mm:ss")}</div>}
                            {record.booked_by && <div><span style={{ color: "#5a5a5a" }}>Booking Type: </span>{record.booked_by === "APP" ? 'Advance Booking' : "On-Site Booking"}</div>}
                            {record.rating && <div><span style={{ color: "#5a5a5a" }}>Rating: </span>{record.rating ? record.rating : "NA"}</div>}
                            {record.parking_name && <div><span style={{ color: "#5a5a5a" }}>Parking: </span>{record.parking_name}</div>}
                        </div>)}
                        onContextMenu={event => event.preventDefault()}
                        linkType={false}
                        rowStyle={() => ({ alignItems: "flex-start", borderBottom: "1px solid #18cc69" })}
                    />
                    :
                    <Datagrid className='valetBookingDataGrid' component={ScrollableTable}>
                        {/* <FunctionField source="vehicle_type" label="Type" render={record => record && renderVehicleType(record)} /> */}
                        <FunctionField source="vehicle_number" label="Vehicle No." sortable={false} render={record => record && record["vehicle_number"] !== null ? <span className='fontWeightSemiBold secondaryColor'>{record["vehicle_number"]}</span> : "NA"} />
                        <FunctionField source="current_status" label="Current Status" sortable={false} render={record => record && record.current_status && StaticValetActivities["DIGITAL"][record.current_status]?.name ? <div className="fontWeightSemiBold" style={{ color: "#78310F", backgroundColor: "#FEF1C7", fontSize: 12, borderRadius: 2, textAlign: "center", padding: "4px 10px" }}>{StaticValetActivities["DIGITAL"][record.current_status].name}</div> : "NA"} />
                        <FunctionField source='username' label='User Name' sortable={false} render={(record) => record && record.username ? record.username : 'NA'} />
                        <FunctionField source='driver_name' label='Driver Name' sortable={false} render={(record) => record && record.driver_name ? record.driver_name : 'NA'} />
                        <FunctionField source="mobile_number" label="Mobile Number" sortable={false} render={record => record && record.mobile_number ? record.mobile_number : "NA"} />
                        <FunctionField source='amount' label="Total Payment" sortable={false}
                            render={record => record && (
                                <div style={{ display: "flex", justifyContent: "center", alignItems: "center", flexDirection: "column", textAlign: 'center' }}>
                                    <div className='fontWeightBold' style={{ fontSize: 12, color: "#6D6D6D" }}>{record.amount && record.amount > 0 ? `₹ ${record.amount}` : "-"}</div>
                                    <div className='fontWeightBold' style={{ width: 50, fontSize: 10, padding: "1px 0px", borderRadius: 2, ...PAYMENT_STATUS[PAYMENT_STATUS[record.status] ? PAYMENT_STATUS[record.status] : PAYMENT_STATUS["DEFAULT"] ]}}>{PAYMENT_STATUS[record.status] ? PAYMENT_STATUS[record.status].label : record.status}</div>
                                </div>)}
                        />
                        <FunctionField source='amount' label="Payment Stage" sortable={false}
                            render={record => record && (
                                <div style={{ display: "flex", justifyContent: "center", alignItems: "center", flexDirection: "column", textAlign: 'center' }}>
                                    <div className='fontWeightBold' style={{ fontSize: 12, color: "#6D6D6D" }}>{record && record.is_paid === 1 ? "Pre Paid" : record.is_paid === 4 ? "Mid Way" : record.is_paid === 2 ? "Handover" : 'NA'}</div>
                                    <div className='fontWeightBold' style={{ fontSize: 10, padding: "1px 4px", borderRadius: 2, textTransform:"capitalize", ...PAYMENT_STATUS["DEFAULT"]}}>{record.payment_portal ? record.payment_portal.replace(/_/g, ' ') : "NA"}</div>
                                </div>)}
                        />
                        <FunctionField source='parking_slots_area_name' label="Parking Area & Slot" sortable={false}
                            render={record => record && (
                                <div style={{ display: "flex", justifyContent: "center", alignItems: "center", flexDirection: "column", textAlign: 'center' }}>
                                    <div style={{ fontSize: 12 }}>{record && record.parking_slots_area_name ? record.parking_slots_area_name : '-'}</div>
                                    {record.parking_slot && <div className='fontWeightBold' style={{ fontSize: 10, padding: "1px 4px", borderRadius: 2, textTransform:"capitalize", backgroundColor: "#F0F7FF", color: "#279AEB"}}>{record.parking_slot ? record.parking_slot : "NA"}</div> }
                                </div>)}
                        />
                        <FunctionField source='created_on' label='Booking Date' render={(record) => record && record.created_on ? moment(record.created_on).format("DD MMM, YYYY") : 'NA'} />
                        <FunctionField source='booked_by' label='Booking Type' sortable={false} render={(record) => record.booked_by === "APP" ? 'Advance Booking' : "On-Site Booking"} />
                        <FunctionField source='rating' label='Rating' sortable={false} render={(record) => record.rating ? record.rating : "NA"} />
                        <FunctionField className="ListIconsContainerValetBookings" render={record => record &&
                            <div className="ListIcons" onClick={() => {
                                setValetDetails(record)
                                setDisplayModal(true)
                            }}>
                                <div style={{ color: "#18CC69", fontSize: 12, marginRight: "6px" }}>View Journey</div>
                                <img src={RightSideArrow} alt='Arrow' width={14} height={14} />
                            </div>
                        } />
                        {/* <FunctionField label="Parking" render={record => record && record.parking_name ? record.parking_name : "-"} /> */}
                    </Datagrid>
                }
            </List>

            {displayModal && <CustomModal displayModal={displayModal} setDisplayModal={setDisplayModal} valetDetails={valetDetails} />}
        </div>
    )
};

const StaticValetActivities = {
    "DIGITAL": {
        "CAR_COLLECTION": {
            name: "Car Collected",
            text: "Car Collected",
            subText: "Your vehicle is in good hands.",
            timestamp: "",
            currentlyOngoing: false
        },
        "PARKING_AND_IMAGE_CAPTURE": {
            name: "Car Parked",
            timestamp: "",
            text: "Car Parked",
            subText: "Your vehicle is in good hands.",
            currentlyOngoing: false
        },
        "VEHICLE_RECALL": {
            name: "Car Recall",
            timestamp: "",
            text: "Car arriving soon",
            subText: "OTP sent to your mobile. Please verify with the operator.",
            currentlyOngoing: false
        },
        // "OTP_SENT": {
        //     name: "OTP Sent",
        //     timestamp: "",
        //     text: "Car arriving soon",
        //     subText: "OTP sent to your mobile. Please verify with the operator.",
        //     currentlyOngoing: false
        // },
        "CAR_ARRIVED": {
            name: "Car Arrived",
            timestamp: "",
            text: "Car Arrived",
            subText: "Your vehicle is arrived.",
            currentlyOngoing: false
        },
        "CAR_HANDOVER": {
            name: "Car Handover",
            timestamp: "",
            text: "Car Handed Over",
            subText: "Your vehicle is in good hands.",
            currentlyOngoing: false
        }
    },
    "NON-DIGITAL": {
        "CAR_COLLECTION": {
            name: "Car Collected",
            text: "Car Collected",
            subText: "Your vehicle is in good hands.",
            timestamp: "",
            currentlyOngoing: false
        },
        "PARKING_AND_IMAGE_CAPTURE": {
            name: "Car Parked",
            timestamp: "",
            text: "Car Parked",
            subText: "Your vehicle is in good hands.",
            currentlyOngoing: false
        },
        "CAR_HANDOVER": {
            name: "Car Handover",
            timestamp: "",
            text: "Car Handed Over",
            subText: "Your vehicle is in good hands.",
            currentlyOngoing: false
        }
    },
}

const activitiesValue = {
    "Car Collected": "CAR_COLLECTION",
    "Car Parked": "PARKING_AND_IMAGE_CAPTURE",
    "Car Recall": "VEHICLE_RECALL",
    "Car Arrived": "CAR_ARRIVED",
    "Car Handover": "CAR_HANDOVER"
}

const CustomModal = ({ displayModal, setDisplayModal, valetDetails }) => {
    const { id, mobile_number, skip_car_parked_activity } = valetDetails
    const [loading, setLoading] = useState(false);
    const [valetActivities, setValetActivities] = useState(null)

    const fetchData = async () => {
        if (!id) return notify("Valet ID required", "warning")
        resetStates()
        setLoading(true);
        try {
            const activitiesResponse = await fetch(`${config.HOST_NAME}/crm/v3/valet/bookings/${id}/activities`,
                {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
                        'RefreshToken': `Bearer ${sessionStorage.getItem('refresh_token')}`,
                    }
                }
            );
            const activitiesData = await activitiesResponse.json();
            if (!activitiesData.data[0]) return
            const data = activitiesData.data
            const isDigitalProcess = mobile_number ? true : false
            const currentlyOngoingActivity = data[data.length - 1]["action"]
            const activitiesStatusObj = {...StaticValetActivities[isDigitalProcess ? "DIGITAL" : "NON-DIGITAL"]}
            let updateActivitiesStatusArray = Object.keys(activitiesStatusObj).map((val) => {
                let findActivity = data.find((v) => v.action === val)
                if (!findActivity) return activitiesStatusObj[val]
                let updatedVal = { ...activitiesStatusObj[val], timestamp: findActivity?.created_on, currentlyOngoing: val === currentlyOngoingActivity }

                if (findActivity['related_data']) {
                    const images = findActivity["related_data"]['images']
                    if (images) {
                        const multipleImages = images
                        const parkingImage = images.find(img => img.action === val);
                        if (parkingImage && parkingImage.image_url) updatedVal.imageUrl = parkingImage.image_url
                        if(multipleImages && multipleImages[0]) updatedVal.multipleImages = multipleImages
                    }
                }

                if (updatedVal.name === "Car Parked") {
                    const imageUrl = findActivity['related_data'] ? findActivity["related_data"]['image_url'] : ""
                    if (imageUrl) updatedVal.imageUrl = imageUrl
                }
                if (updatedVal.name === "Car Recall") {
                    const recallTime = findActivity['related_data'] ? findActivity["related_data"]['recall_time'] : 15
                    const remainingSeconds = moment(findActivity.created_on).add(recallTime, 'minutes').diff(moment(), 'seconds')

                    if (recallTime && remainingSeconds) {
                        updatedVal.recallTime = recallTime
                        updatedVal.remainingSeconds = remainingSeconds
                    }
                }

                activitiesStatusObj[val] = updatedVal
                return updatedVal
            })
            if(currentlyOngoingActivity === "CAR_HANDOVER") updateActivitiesStatusArray = updateActivitiesStatusArray.filter((val) => val.timestamp)
            if (isDigitalProcess && activitiesStatusObj["VEHICLE_RECALL"]?.timestamp !== "") {
                if (activitiesStatusObj["PARKING_AND_IMAGE_CAPTURE"]?.timestamp === "") {
                    delete activitiesStatusObj["PARKING_AND_IMAGE_CAPTURE"]
                    updateActivitiesStatusArray = updateActivitiesStatusArray.filter((val) => val.name !== "Car Parked")
                }
            }
            if (skip_car_parked_activity) {
                delete activitiesStatusObj["PARKING_AND_IMAGE_CAPTURE"]
                updateActivitiesStatusArray = updateActivitiesStatusArray.filter((val) => val.name !== "Car Parked")
            }

            setValetActivities(updateActivitiesStatusArray)

        } catch (error) {
            console.log(error)
            notify('Something went wrong', "warning");
        } finally {
            setLoading(false);
        }
    };

    const resetStates = () => {
        setValetActivities(null)
    }

    useEffect(() => {
        fetchData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div className='valet_styles'>
            <div className={`CustomPopup ${displayModal ? "Show" : ""}`}>
                <div style={{ padding: "18px 18px" }}>
                    <div style={{ display: "flex", justifyContent: "flex-start", alignItems: "flex-start", }}>
                        <div className='fontWeightSemiBold' style={{ flex: 1, color: "#334d6e", fontSize: 16 }}>
                            Valet Logs
                        </div>
                        <IconButton style={{ width: 25, height: 25 }} onClick={() => setDisplayModal(!displayModal)}>
                            <ClearIcon style={{ fontSize: 20 }} />
                        </IconButton>
                    </div>
                    {!loading && valetActivities &&
                        <div style={{ marginTop: "16px", borderRadius: "8px", padding: "16px" }}>
                            {
                                valetActivities.map((activity, i) => {
                                    return <div key={i} style={{ display: "flex", justifyContent: "flex-start", alignItems: "flex-start" }}>
                                        <div style={{ display: "flex", justifyContent: "center", alignItems: "center", flexDirection: "column" }}>
                                            <div className='valet_circle' style={{ backgroundColor: activity.timestamp ? "#24A147" : "#DCDCDC" }}>
                                                {activity.timestamp
                                                    ? <img src={RightTickImg} alt='Right Tick' width={15} height={12} />
                                                    : <div className='fontWeightRegular' style={{ color: "#7C7C7C", fontSize: "14px" }}>{i + 1}</div>
                                                }
                                            </div>
                                            {valetActivities.length !== i + 1 && <div className='valet_vertical_line'></div>}
                                        </div>
                                        <div style={{ flex: 1, display: "flex", justifyContent: "flex-start", alignItems: "flex-start", marginLeft: "8px", marginTop: !activity.timestamp ? "5px" : "0px", }}>
                                            <div style={{ flex: 1 }}>
                                                <div className='fontWeightSemiBold' style={{ color: "#192A3E", fontSize: "14px" }}>{activity.name}</div>
                                                {activity.timestamp && <div className='fontWeightSemiBold' style={{ color: "#7C7C7C", fontSize: "11px" }}>{moment(activity.timestamp).format('MMM D, YYYY • h:mm A')}</div>}
                                            </div>

                                            {/* {activity.imageUrl && <ImageGalleryDialog thumbnail={true} record={[activity.imageUrl]} getImages={(record) => [activity.imageUrl]} />} */}
                                            {activity.multipleImages && activity.multipleImages[0] && <MultipleImageViewerWithText thumbnail={true} showMultipleThumbnails={true} record={activity.multipleImages} getImages={(record) => record.map((val) => val.image_url)} />}
                                        </div>
                                    </div>
                                })
                            }
                        </div>
                    }
                    {loading && !valetActivities && <LoadingActivities />}
                    {!loading && !valetActivities && <div className='fontWeightSemiBold' style={{ color: "#192A3E", fontSize: "14px", marginTop: "16px", borderRadius: "8px", padding: "16px" }}>Journey has not been started yet.</div>}
                </div>
            </div>
            <div
                className={`CustomOverlay ${displayModal ? "Show" : ""}`}
                onClick={() => setDisplayModal(!displayModal)}
            />
        </div>
    )
};

const LoadingActivities = () => {
    return (
        <div style={{ marginTop: "16px", borderRadius: "8px", border: "1px solid #EFEFEF", padding: "16px" }}>
            {
                [1, 2, 3, 4].map((i) => (
                    <div key={i} style={{ display: "flex", justifyContent: "flex-start", alignItems: "flex-start" }}>
                        <div style={{ display: "flex", justifyContent: "center", alignItems: "center", flexDirection: "column" }}>
                            <div className='valet_circle' style={{ backgroundColor: "#DCDCDC" }}>
                                <div className='fontWeightRegular' style={{ color: "#7C7C7C", fontSize: "14px" }}>{i}</div>

                            </div>
                            <div className='valet_vertical_line'></div>
                        </div>
                        <div style={{ marginLeft: "8px", marginTop: "5px" }}>
                            <Skeleton variant="text" height={22} width="200px" />
                            <Skeleton variant="text" height={22} width="150px" />
                        </div>
                    </div>
                ))
            }
        </div>
    );
};

function SummaryCard({ title, loading, data, getValue, getDistributedValues, getDistributedLabels, getDistributedIcons, getDistributedPercentage, getDistributedValuePercentage, getSubPercentage, getDistributedAmount, showDonutChart, clickable, showProgressBar = false, getDistributedCount, showTooltip = false, getNestedTypes = null, isPaymentType = true, activityType, setActivityType, style }) {
    console.log("act", activityType)
    const classes = useStyles();

    return <Paper style={{ position: "relative", display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', boxShadow: "0px 4px 15px #0000001a", padding: "14px 20px 18px 20px", cursor: clickable ? "pointer" : "", ...style }}>
        <div style={{ flex: 1 }}>
            <div>
                <div style={{ display: "flex", justifyContent: "space-between" }}>
                    <Typography className={classes.title} style={{ textTransform: "capitalize" }}>{title}</Typography>

                    {getValue(data) > 0 && ["Collected", "Handed Over"].includes(title) && setActivityType &&
                        <Button style={{ minWidth: "80px", background: "none", border: "none", cursor: "pointer", backgroundColor: "#109CF11A", color: "#5E8DD3", padding: "1px 12px", borderRadius: 2, fontSize: 9, textTransform: "none", fontWeight: "normal" }} onClick={() => setActivityType(activityType === title && activityType ? null : activityType === null ? title : activityType && activityType !== title ? title : null)}><p style={{ lineHeight: 0, marginRight: 5 }}>{activityType === title ? "Details" : "Filter"}</p>
                            <img src={activityType === title ? downArrow : sideArrow} alt='arrow' />
                        </Button>
                    }
                </div>
                {
                    !loading && data ?
                        <div style={{ display: "flex", gap: 10, alignItems: getSubPercentage && (getSubPercentage(data) || getSubPercentage(data) === 0) ? "center" : "", flexWrap: "wrap" }}>
                            {getDistributedCount && getDistributedCount(data) && <Typography className={classes.mainValue} style={{ color: "#334D6E", marginRight: 10 }}>{getDistributedCount(data)}</Typography>}
                            <Typography className={classes.mainValue}>{["Amount"].includes(title) || ["Amount"].includes(activityType) ? "₹" : ""} {getValue(data)}</Typography>
                            {getSubPercentage && (getSubPercentage(data) || getSubPercentage(data) === 0) &&
                                <div style={{ display: "flex", alignItems: "center", backgroundColor: "#18CC6919", fontSize: 9, color: "#18CC69", padding: "0px 10px", height: 15, borderRadius: 10, fontFamily: "Poppins-SemiBold" }}>
                                    {getSubPercentage(data)}%
                                </div>
                            }
                        </div>
                        :
                        !loading && !data ?
                            <div style={{ display: "flex", gap: 10, alignItems: getSubPercentage && (getSubPercentage(data) || getSubPercentage(data) === 0) ? "center" : "", flexWrap: "wrap" }}>
                                <Typography className={classes.mainValue}>{["Amount"].includes(title) || ["Amount"].includes(activityType) ? "₹" : ""} {getValue(data) ? getValue(data) : 0}</Typography>
                            </div>
                            :
                            <Skeleton variant="text" height={42} width="50px" />
                }
            </div>
            {
                !loading && data ? getDistributedLabels(data).map((dL, i) => (
                    <div>
                        <div key={dL} className={classes.flexContainer}>
                            <div style={{ display: "flex", justifyContent: "flex-start", alignItems: "center" }}>
                                <img className={classes.summaryVehicleIcon} src={getDistributedIcons(data)[i]} alt={dL} />
                                <Typography className={classes.summaryBoxLabel1}>{dL}:</Typography>
                            </div>
                            <div style={{ flex: 1, display: "flex", justifyContent: "flex-end", alignItems: "flex-end", gap: 10, flexWrap: "wrap" }}>
                                <Typography className={classes.summaryBoxValue1}>{["Amount"].includes(title) || ["Amount"].includes(activityType) ? "₹" : ""} {getDistributedValues(data)[i]}</Typography>

                                {isPaymentType && getDistributedAmount && getDistributedAmount(data) && <>
                                    <Typography className={classes.summaryBoxValue1} style={{ color: "#18CC69" }}>₹ {getDistributedAmount(data)[i].toFixed(2)}</Typography>                            </>
                                }
                                {!["Manual"].includes(dL) && getDistributedValuePercentage && getDistributedValuePercentage(data) && <>
                                    <Typography className={classes.summaryBoxValue1} style={{ color: "#18CC69", fontSize: 9 }}>{getDistributedValuePercentage(data)[i].toFixed(2)}%</Typography>
                                    {showTooltip && <Tooltip arrow title={`This percentage is the overall share for this gate for ${dL}`} classes={{ tooltip: classes.tooltip }}><InfoOutlinedIcon style={{ fontSize: 12, color: "#888" }} /></Tooltip>}
                                </>
                                }
                            </div>
                        </div>

                        {getNestedTypes && getNestedTypes(data) !== null &&
                            [Object.keys(getNestedTypes(data))[i]].map((val) => (
                                <>
                                    {getNestedTypes(data)[val]["types"] && Object.keys(getNestedTypes(data)[val]["types"]).map((subType) => (
                                        <div key={subType} className={classes.flexContainer} style={{ marginLeft: 20 }}>
                                            <div style={{ display: "flex", justifyContent: "flex-start", alignItems: "center" }}>
                                                <img className={classes.summaryVehicleIcon} src={AnalyticDistributionImgs[subType]?.["img"]} alt={subType} />
                                                <Typography className={classes.summaryBoxLabel1}>{subType}:</Typography>
                                            </div>
                                            <div style={{ flex: 1, display: "flex", justifyContent: "flex-end", alignItems: "flex-end", gap: 10, flexWrap: "wrap" }}>
                                                <Typography className={classes.summaryBoxValue1}>{getNestedTypes(data)[val]["types"] && getNestedTypes(data)[val]["types"][subType]["count"] ? `${getNestedTypes(data)[val]["types"][subType]["count"]}` : '0'} </Typography>
                                                {isPaymentType && <Typography className={classes.summaryBoxValue1} style={{ color: "#18CC69" }}>{getNestedTypes(data)[val]["types"] && getNestedTypes(data)[val]["types"][subType]["amount"] ? `₹ ${getNestedTypes(data)[val]["types"][subType]["amount"].toFixed(2)}` : '₹ 0'} </Typography>}
                                                <Typography className={classes.summaryBoxValue1} style={{ color: "#18CC69", fontSize: 9 }}>{getNestedTypes(data)[val]["types"] && getNestedTypes(data)[val]["types"][subType]["percentage"] ? getNestedTypes(data)[val]["types"][subType]["percentage"].toFixed(2) : '0'}%</Typography>
                                            </div>
                                        </div>
                                    ))}
                                </>
                            ))
                        }


                    </div>
                )) :
                    !loading && !data ? null
                        :
                        ["50", "40"].map((width, index) => (
                            <Skeleton variant="text" width={width} height={18} key={index} />
                        ))
            }
        </div>

        {showProgressBar && data && getDistributedPercentage &&
            <div className="horizontal-bar" style={{ position: "absolute", bottom: 0, left: 0, width: "100%" }}>
                {getDistributedPercentage(data).map((item, index) => (
                    <Tooltip arrow title={`${item.percentage}%`} classes={{ tooltip: classes.tooltip }}>
                        <div key={index} className="bar-segment" style={{ width: `${item.percentage}%`, backgroundColor: item.color }}>
                        </div>
                    </Tooltip>
                ))}
            </div>
        }
    </Paper>

}